// API base URL - use environment variable or default to API domain
// For production: https://api.evaluation.elcexercises.org
// For development: http://localhost:8906
const API_BASE = process.env.REACT_APP_API_BASE || 
                 process.env.REACT_APP_SERVER_URL ||
                 // Default to production URL unless explicitly in development
                 (process.env.NODE_ENV === 'development' 
                   ? 'http://localhost:8906'
                   : 'https://api.evaluation.elcexercises.org');

// Keep SERVER_URL for backwards compatibility
const SERVER_URL = API_BASE;

module.exports = { API_BASE, SERVER_URL };
